import { GET_ACCOMMODATION_TYPES } from "@/actions/GET_ACCOMMODATION_TYPES.ts";
import { AccommodationType } from "@/helpers/types/types.ts";
import { useQuery } from "@apollo/client";

export interface GetAccommodationTypesResponse {
  accommodationTypes: AccommodationType[];
}
export const useGetAccommodationTypes = () => {
  const { data, loading } = useQuery<GetAccommodationTypesResponse>(GET_ACCOMMODATION_TYPES);

  return {
    accommodationTypes: data?.accommodationTypes || [],
    getAccommodationTypesLoading: loading,
  };
};
